import { render, staticRenderFns } from "./bank-relationship-onboarding.vue?vue&type=template&id=3fe67888"
import script from "./bank-relationship-onboarding.vue?vue&type=script&lang=js"
export * from "./bank-relationship-onboarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports